module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "home"
  }, [_c('div', {
    staticClass: "home__presentation"
  }, [_c('h1', [_vm._v("Declick est un outil clé en main !")]), _c('p', [_vm._v("En classe, en atelier ou à la maison, il permet d'aborder les bases du\ncode informatique et de les appliquer à travers des projets, individuels\nou collectifs, d'applications ou de jeux vidéo.")]), _c('a', {
    attrs: {
      "href": "https://www.instagram.com/associationcolombbus/",
      "target": "_blank"
    }
  }, [_c('img', {
    staticClass: "instaBannier",
    attrs: {
      "src": require("../assets/instaBannier.png")
    }
  })])]), _c('div', {
    staticClass: "home__box"
  }, [_c('img', {
    staticClass: "home__robot-train",
    attrs: {
      "src": require("../assets/images/figures/robot-train.svg"),
      "alt": "robot logo declick"
    }
  }), _c('h3', [_vm._v("les parcours")]), _c('p', [_vm._v("La section « APPRENDRE » regroupe des parcours qui vous permettent\nd'assimiler progressivement des notions de programmation.")])]), _c('div', {
    staticClass: "home__box"
  }, [_c('img', {
    staticClass: "home__robot-idea",
    attrs: {
      "src": require("../assets/images/figures/robot-idea.svg"),
      "alt": "robot logo declick"
    }
  }), _c('h3', [_vm._v("l'espace créatif")]), _c('p', [_vm._v("La section « CRÉER » vous propose un environnement de travail où vous\npouvez composer avec les notions acquises pour créer vos propres jeux et\napplications.")])]), _c('div', {
    staticClass: "home__box"
  }, [_c('img', {
    staticClass: "home__robot-observe",
    attrs: {
      "src": require("../assets/images/figures/robot-observe.svg"),
      "alt": "robot logo declick"
    }
  }), _c('h3', [_vm._v("l'espace découverte")]), _c('p', [_vm._v("Dans la section « JOUER » retrouvez et testez les jeux ou les\napplications créés par la communauté Declick.")])]), _c('h2', [_vm._v("declick en vidéo")]), _c('div', {
    staticClass: "home__video"
  }, [_c('iframe', {
    attrs: {
      "src": "https://player.vimeo.com/video/211507001?title=0&byline=0&portrait=0",
      "frameborder": "0",
      "webkitallowfullscreen": "webkitallowfullscreen",
      "mozallowfullscreen": "mozallowfullscreen",
      "allowfullscreen": "allowfullscreen",
      "alt": "video presentation declick"
    }
  })]), _c('h2', [_vm._v("notre approche")]), _c('div', {
    staticClass: "home__box"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/figures/target.svg")
    }
  }), _c('h3', [_vm._v("notre mission")]), _c('p', [_vm._v("Declick a été conçu pour initier les 8-15 ans au code et à la création\nnumérique, à travers la programmation écrite. La plateforme constitue\nainsi une étape intermédiaire entre les éditeurs visuels (type Scratch)\net les vrais environnements de programmation.")])]), _c('div', {
    staticClass: "home__box"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/figures/chart.svg")
    }
  }), _c('h3', [_vm._v("notre pédagogie")]), _c('p', [_vm._v("Declick est le fruit de plus de 10 ans d'expérience de l'enseignement de\nla programmation auprès des jeunes, notamment en zone d'éduction\nprioritaire : la plateforme est utilisée quotidiennement pour l'animation\nd'ateliers dans les collèges les écoles élémentaires et les centres\nd'animation.")])]), _c('div', {
    staticClass: "home__box"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logos/Octocat.svg")
    }
  }), _c('h3', [_vm._v("un logiciel libre")]), _c('p', [_vm._v("Declick est gratuit et libre : le code source de la plateforme est\nhébergé sur GitHub et diffusé sous license GPL 3.0. Si vous voulez\ncontribuer au développement, n'hésitez pas à nous contacter !")]), _c('img', {
    staticClass: "home__tag",
    attrs: {
      "src": require("../assets/images/figures/made-in-France.svg")
    }
  })]), _c('div', {
    staticClass: "home__about-us"
  }, [_c('h3', [_vm._v("l'association Colombbus")]), _c('p', [_vm._v("Depuis 18 ans nous agissons pour l'éducation la formation, l'insertion\nsociale et professionnelle grâce à l'informatique et à internet. À\ntravers nos activités nous facilitons l'usage et l'appropriation des\noutils numériques qui deviennent alors vecteurs d'inclusion, de\ndéveloppement personnel et de lien social.")]), _c('a', {
    attrs: {
      "href": "https://www.colombbus.org/",
      "target": "_blank"
    }
  }, [_vm._v("en savoir plus")])]), _c('div', {
    staticClass: "home__partners"
  }, [_c('h3', [_vm._v("nos partenaires éducatifs")]), _c('div', {
    staticClass: "home__logo-group"
  }, [_c('a', {
    attrs: {
      "href": "https://pixees.fr/classcode-v2/",
      "title": "Class'Code",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logos/ClassCode.svg")
    }
  })]), _c('a', {
    attrs: {
      "href": "https://d-clicsnumeriques.org/",
      "title": "D-Clics Numériques",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logos/D-Clics-Numeriques.svg")
    }
  })]), _c('a', {
    attrs: {
      "href": "https://www.reseau-canope.fr/",
      "title": "Réseau Canopé",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logos/Canope.svg")
    }
  })]), _c('a', {
    attrs: {
      "href": "http://www.ensiie.fr/",
      "title": "ENSIIE",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logos/ENSIIE.svg")
    }
  })]), _c('a', {
    attrs: {
      "href": "http://www.france-ioi.org/",
      "title": "France-IOI",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logos/France-IOI.svg")
    }
  })])]), _c('h3', [_vm._v("nos partenaires publics")]), _c('div', {
    staticClass: "home__logo-group"
  }, [_c('a', {
    attrs: {
      "href": "http://www.education.gouv.fr/",
      "title": "Ministère de l'Éducation nationale",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logos/Ministere-Education-nationale.svg")
    }
  })]), _c('a', {
    attrs: {
      "href": "http://www.europe-en-france.gouv.fr/",
      "title": "L'Europe s'engage",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logos/lEurope-sengage.svg")
    }
  })]), _c('a', {
    attrs: {
      "href": "https://www.paris.fr/",
      "title": "Mairie de Paris",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logos/Mairie-de-Paris.svg")
    }
  })])]), _c('h3', [_vm._v("nos mécènes")]), _c('div', {
    staticClass: "home__logo-group"
  }, [_c('a', {
    attrs: {
      "href": "https://www.vivendi.com/create-joy-fr/",
      "title": "Vivendi Create Joy",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logos/Vivendi-Create-Joy.svg")
    }
  })]), _c('a', {
    attrs: {
      "href": "https://www.thalesgroup.com/fr",
      "title": "Thales",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logos/Thales.svg")
    }
  })]), _c('a', {
    attrs: {
      "href": "https://www.fondation-sncf.org/fr/",
      "title": "Fondation SNCF",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logos/Fondation-SNCF.svg")
    }
  })]), _c('a', {
    attrs: {
      "href": "https://www.sap.com/france/index.html",
      "title": "SAP",
      "target": "_blank"
    }
  }, [_c('img', {
    attrs: {
      "src": require("../assets/images/logos/SAP_grad_R_pref.svg")
    }
  })])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-20f06d9c!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/HomePage.vue
// module id = 584
// module chunks = 2